import { initializeApp } from 'firebase/app';
import { getAuth, browserLocalPersistence, setPersistence } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyCsplenWnarT80E2_h-8i0yjLSL_5BB3q0",
  authDomain: "puffies-b24ce.firebaseapp.com",
  projectId: "puffies-b24ce",
  storageBucket: "puffies-b24ce.firebasestorage.app",
  messagingSenderId: "57744622472",
  appId: "1:57744622472:web:36a4739d5626006d34703d",
  measurementId: "G-S2C8S6Z6G1"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const functions = getFunctions(app);

// Set persistence to LOCAL to handle network issues better
setPersistence(auth, browserLocalPersistence)
  .catch((error) => {
    console.error("Error setting persistence:", error);
  });

export { app, auth, functions }; 